export default __webpack_public_path__ + "static/media/background-video.ced593dc.mp4";